export default __webpack_public_path__ + "static/media/shipped.611d7c56.svg";